import { TFunction } from "i18next";

interface Option {
  value: string;
  label: string;
}

const tr = (t: TFunction, key: string) => String(t(key, key));

const ALL = (t: TFunction): Option => ({
  value: "",
  label: tr(t, "filters.all"),
});

export const STATUS_ENROLLMENT_VALUES = [
  "E",
  "W",
  "C",
  "P",
  "R",
  "N",
  "T",
  "PA",
  "PW",
  "PA0",
];

export const ENROLL_TYPE_VALUES = [
  "TOP",
  "TOP_MANDATORY",
  "AUTO",
  "BOTTOM",
  "PRE_AUTO",
  "PRE_BOTTOM",
];

export const GROUP_TYPE_VALUES = ["STATIC", "DYNAMIC"];

export const PRE_STATUS_VALUES = ["T", "PW", "PA"];

export const buildStatusEnrollmentOptions = (t: TFunction): Option[] => [
  ALL(t),
  ...STATUS_ENROLLMENT_VALUES.map((v) => ({
    value: v,
    label: tr(t, `status.${v.toLowerCase()}`),
  })),
];

export const buildEnrollTypeOptions = (t: TFunction): Option[] => [
  ALL(t),
  ...ENROLL_TYPE_VALUES.map((v) => ({
    value: v,
    label: tr(t, `enroll-type.${v}`),
  })),
];

export const buildGroupTypeOptions = (t: TFunction): Option[] => [
  ALL(t),
  ...GROUP_TYPE_VALUES.map((v) => ({
    value: v,
    label: tr(t, `group-type.${v}`),
  })),
];

export const buildPreStatusOptions = (t: TFunction): Option[] => [
  ALL(t),
  ...PRE_STATUS_VALUES.map((v) => ({
    value: v,
    label: tr(t, `status.${v.toLowerCase()}`),
  })),
];
